import React from 'react'
import { CssBaseline } from '@mui/material'
import DataViewerAppBar from './components/appBar/DataViewerAppBar'
import ChartContainer from './components/ChartContainer'

function App() {
    return (
        <>
            <CssBaseline />
            <DataViewerAppBar />

            <ChartContainer />
        </>
    )
}

export default App
